// API configuration for NotesCrafter Workers backend

const isDev = (import.meta as any).env?.DEV;

// In production, the API is on the same domain (/api/*)
// In development, use empty string to trigger Vite proxy (/api/* → localhost:8787)
export const API_BASE_URL = isDev
  ? ((import.meta as any).env?.VITE_API_URL || '')
  : '';

/**
 * Make an authenticated API request
 */
export async function apiFetch(
  endpoint: string,
  options: RequestInit = {}
): Promise<Response> {
  const url = `${API_BASE_URL}${endpoint}`;

  const defaultHeaders: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  return fetch(url, {
    ...options,
    credentials: 'include', // Send cookies for auth
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  });
}

/**
 * GET request helper
 */
export async function apiGet<T>(endpoint: string): Promise<T> {
  const res = await apiFetch(endpoint);
  if (!res.ok) {
    const error = await res.json().catch(() => ({ error: 'Request failed' }));
    throw new Error((error as any).message || (error as any).error || `HTTP ${res.status}`);
  }
  return res.json();
}

/**
 * POST request helper
 */
export async function apiPost<T>(endpoint: string, body?: any): Promise<T> {
  const res = await apiFetch(endpoint, {
    method: 'POST',
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    const error = await res.json().catch(() => ({ error: 'Request failed' }));
    throw new Error((error as any).message || (error as any).error || `HTTP ${res.status}`);
  }
  return res.json();
}
